import { render } from "./HomeSpeakers.vue?vue&type=template&id=040230c3"
import script from "./HomeSpeakers.vue?vue&type=script&lang=ts"
export * from "./HomeSpeakers.vue?vue&type=script&lang=ts"
script.render = render

export default script